<template>
  <div class="news-wrap view-container">
    <a-row style="margin-bottom: 10px;" :gutter="{ md: 12 }">
      <a-col :span="4">
        <a-button type="primary" @click="openModal" style="margin-right: 5px;"
          >添加用户</a-button
        >
        <a-popconfirm
          title="确定要删除吗 ?"
          @confirm="() => onDelSelectedUsers()"
        >
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <a-button type="default">删除选中</a-button>
        </a-popconfirm>
      </a-col>
    </a-row>

    <a-table
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="list"
      :pagination="true"
      :bordered="true"
      :rowClassName="tableRowClass"
      :rowSelection="rowSelection"
    >
      <template slot="user" slot-scope="text">
        <a-avatar :src="text">
          <a-icon slot="icon" type="user" />
        </a-avatar>
      </template>
      <template slot="cell" slot-scope="text">
        <span v-html="text" class="cell-text"></span>
      </template>
      <span slot="tags" slot-scope="tags">
        <a-tag v-for="tag in tags" :color="'purple'" :key="tag.id">
          {{ tag.name }}
        </a-tag>
      </span>
      <template slot="operation" slot-scope="text, record">
        <a-popconfirm
          v-if="list.length"
          title="确定删除吗 ?"
          @confirm="() => onDelUser(record.id)"
        >
          <a href="javascript:;"> <a-icon type="delete" />删除 </a>
        </a-popconfirm>
      </template>
    </a-table>
    <TheAddUserForm v-model="visible" @success="fetchUsers" />
  </div>
</template>

<script>
import { getUsers, deleteUser } from '@/api/user-management'
import moment from 'moment'
import TheAddUserForm from './TheAddUserForm'

export default {
  components: { TheAddUserForm },
  data() {
    return {
      columns: [],
      list: [],
      keyword: '',
      selectedRowKeys: [],
      rowSelection: {
        onChange: selectedRowKeys => {
          this.selectedRowKeys = selectedRowKeys
        }
      },
      visible: false
    }
  },

  created() {
    this.columns = [
      {
        title: '头像',
        dataIndex: 'avatar',
        scopedSlots: { customRender: 'user' }
      },
      {
        title: '用户昵称',
        dataIndex: 'name',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '账号',
        dataIndex: 'username',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '角色',
        dataIndex: 'roles',
        scopedSlots: { customRender: 'tags' }
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        scopedSlots: { customRender: 'cell' },
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
      }
    ]

    this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      let res = await getUsers()
      if (res.code === 200) {
        const roles = res.result
        this.list = roles
      }
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    },
    openModal() {
      this.visible = true
    },
    onDelUser(id) {
      const ids = [id].join(',')
      this.deleteUsers(ids)
    },
    deleteUsers(ids = '') {
      deleteUser(ids).then(res => {
        if (res.code === 200) {
          this.fetchUsers()
          this.$notification['success']({
            message: '成功',
            description: '删除成功',
            duration: 3
          })
        }
      })
    },
    onDelSelectedUsers() {
      const { selectedRowKeys: keys } = this
      if (keys && keys.length > 0) {
        const ids = keys.join(',')
        this.deleteUsers(ids)
        this.selectedRowKeys = []
      } else {
        this.$notification['info']({
          message: '提示',
          description: '请选择删除内容',
          duration: 2
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.file {
  border: 1px solid rgb(172, 172, 172) !important;
}
.image {
  width: 100px;
  height: 100px;
}
.cell-text {
  max-width: 600px;
  display: block;
  overflow: hidden;
}
</style>
